<template>
<div class="col-md-12">
  <h1>{{title}}</h1>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-12 border-right-blue-grey border-right-lighten-3">
      <div class="card">
        <div class="float-left card-count">
          <span class="font-large-3 text-bold-300 primary">{{totalLPOCount}}</span>
        </div>
        <div class="float-left card-text">
          <span class="blue-grey darken-1 block">LPO</span>
          <span class="blue-grey darken-1 block">Generated</span>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 col-12">
      <div class="card">
        <div class="float-left card-count">
          <span class="font-large-3 text-bold-300 warning">{{waitingLPOCount}}</span>
        </div>
        <div class="float-left card-text">
          <span class="blue-grey darken-1 block">LPO</span>
          <span class="blue-grey darken-1 block">Waiting Approval</span>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 col-12">
      <div class="card">
        <div class="float-left card-count">
          <span class="font-large-3 text-bold-300 success">{{approvedLPOCount}}</span>
        </div>
        <div class="float-left card-text">
          <span class="blue-grey darken-1 block">LPO</span>
          <span class="blue-grey darken-1 block">Approved</span>
        </div>
      </div>
    </div>
    <div class="col-lg-3 col-md-6 col-12">
      <div class="card">
        <div class="float-left card-count">
          <span class="font-large-3 text-bold-300 danger">{{rejectedLPOCount}}</span>
        </div>
        <div class="float-left card-text">
          <span class="blue-grey darken-1 block">LPO</span>
          <span class="blue-grey darken-1 block">Rejected</span>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import api from '../api'
export default {
  name: 'Home',
  data(){
    return{
      title : "Dashboard",
      purchaseList: []
    }
  },
  computed: {
    totalLPOCount: function () {
      return this.purchaseList.length
    },
    rejectedLPOCount: function (){
      const list = this.purchaseList.filter(function (obj) {
        return obj.order_status < 0
      })
      return list.length
    },
    approvedLPOCount: function (){
      const list = this.purchaseList.filter(function (obj) {
        return obj.order_status > 0
      })
      return list.length
    },
    waitingLPOCount: function (){
      const list = this.purchaseList.filter(function (obj) {
        return obj.order_status == 0
      })
      return list.length
    }
  },
  methods: {
    getPurchases: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_purchases", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
          } else {
            this.purchaseList = data.purchaseList;
          }
        });
    },
    getProducts: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_products", list)
        .then((response) => {
          var data = response.data;
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            console.log(response.data.values)
          } else {
            this.$store.commit('SET_PRODUCTS', data.productList)
          }
        });
    }
  },
  mounted () {
    this.getPurchases()
    this.getProducts()
  }
}
</script>

<style scoped>
.card{
    position: relative;
    display: flex;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border-radius: 0.5rem;
    padding:1.5rem;
    border: 0;
    box-shadow: 0 2px 15px -3px rgb(0 0 0 / 7%), 0 10px 20px -2px rgb(0 0 0 / 4%);
}
.font-large-3 {
    font-size: 4.8rem!important;
}
.text-bold-300 {
    font-weight: 300;
}
.primary {
    color: #00B5B8!important;
}
.float-left{
  float: left;
}
.blue-grey.darken-1 {
    color: #546E7A!important;
}
.blue-grey {
    color: #607D8B!important;
}
.card-text{
  margin-top: 16px;
  margin-left: 15px;
}
.warning {
    color: #FFA87D!important;
}
.success {
    color: #16D39A!important;
}
.danger {
    color: #FF7588!important;
}
</style>